import { render, staticRenderFns } from "./EventReport.vue?vue&type=template&id=7020fd62&"
import script from "./EventReport.vue?vue&type=script&lang=js&"
export * from "./EventReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports